import React from 'react';

import { sourceType } from '@components/shared/widgets/ContactUs';
import { useDispatch } from '@globalStore/storeProvider';
import Link from 'next/link';

const EnquirySection = ({
  title,
  focusText,
  desc,
  onlyPrimaryCTA = false,
  buttonCTA,
  buttonLink,
}) => {
  const dispatch = useDispatch();
  return (
    <div className="mb-10 flex items-center justify-center">
      <div className="relative my-6 flex w-11/12 w-full flex-col rounded-xl bg-black md:hidden">
        <img
          width="100%"
          className="absolute top-0"
          src="/assets/images/Placement Statistics/Morph LineMobile.webp"
          alt="i"
        />
        <section className="z-1   flex w-full flex-col items-center justify-center rounded-3xl bg-black pt-8 text-center md:px-4 md:py-8">
          <div className="flex flex-col gap-y-4 px-4">
            <p className=" font-satoshi-bold text-2xl font-bold   text-red">
              {focusText || '100% Job Assurance with AlmaX Career Track'}
            </p>
            <h2 className="text-white">{title || 'Take a moonshot at your tech career'}</h2>
            <p className="font-normal text-gray">{desc || 'Explore our courses to enrol today'}</p>
            <div className="z-1 relative flex flex-col items-center gap-y-6">
              {buttonLink ? (
                <a
                  className="center btn-red w-3/5 font-satoshi-medium text-[16px] font-semibold !normal-case md:text-sm"
                  href={buttonLink}
                  target="_blank"
                >
                  {buttonCTA}
                </a>
              ) : (
                <Link href={'/courses'} as={'/courses'} passHref>
                  <a className="center btn-red w-3/5 font-satoshi-bold text-[14px] font-bold  md:text-sm">
                    Explore Courses
                  </a>
                </Link>
              )}
              {!onlyPrimaryCTA && (
                <button
                  className="center btn-white w-3/5 text-[14px] md:text-sm"
                  onClick={() => {
                    sessionStorage.setItem('sourceType', sourceType.placement_statistics);
                    dispatch({
                      type: 'SET_WIDGET_SOURCE',
                      payload: sourceType.callback,
                    });
                  }}
                >
                  Talk to Admissions Team
                </button>
              )}
            </div>
          </div>

          <div className="mt-8 flex items-end justify-center md:mb-6">
            <img
              width="100%"
              className=" z-2 relative"
              src="/assets/images/Placement Statistics/peopleMobile.webp"
              alt="i"
            />
          </div>
        </section>
      </div>

      <div className="relative hidden items-center justify-center bg-light-gray-2 px-4 py-8 pb-0 md:flex md:flex-col md:px-0">
        <img
          width="100%"
          className="absolute bottom-0 left-0 right-0 z-0 opacity-25"
          src="/assets/images/Placement Statistics/Morph Line.webp"
          alt="i"
        />
        <section className="z-1 my-20 flex w-[87%] flex-col rounded-3xl bg-black text-center">
          <div className="mt-4 gap-y-6">
            <p className=" font-satoshi-medium text-red">
              {focusText || '100% Job Assurance with AlmaX Career Track'}
            </p>
            <h1 className="font-satoshi-bold text-white">
              {title || 'Take a moonshot at your tech career'}
            </h1>
            <p className="font-satoshi-medium text-gray">
              {desc || 'Explore our courses to enrol today'}
            </p>
            <div className="z-1 relative mt-8 flex flex-col gap-y-8 md:flex-row md:justify-center md:gap-x-8">
              {buttonLink ? (
                <a
                  className="center btn-red font-satoshi-medium text-[0.7rem] font-semibold !normal-case md:text-sm"
                  href={buttonLink}
                  target="_blank"
                >
                  {buttonCTA}
                </a>
              ) : (
                <Link href={'/courses'} as={'/courses'} passHref>
                  <a className="center btn-red text-center font-satoshi-medium text-[0.7rem] font-semibold md:text-sm">
                    Explore Courses
                  </a>
                </Link>
              )}
              {!onlyPrimaryCTA && (
                <button
                  className="center btn-white font-satoshi-medium  text-[0.7rem] md:text-sm"
                  onClick={() => {
                    dispatch({
                      type: 'SET_WIDGET_SOURCE',
                      payload: sourceType.placement_statistics,
                    });
                  }}
                >
                  Talk to Admissions Team
                </button>
              )}
            </div>
          </div>

          <div className="flex items-end justify-center">
            <img
              width="90%"
              className=" z-2 relative mb-1 ml-1"
              src="/assets/images/Placement Statistics/people.webp"
              alt="i"
            />
          </div>
        </section>
      </div>
    </div>
  );
};

export default EnquirySection;
